<template>
   <div class="col-12">
      <!-- PERFIL - CONFIGURAÇÕES -->
        <section class="no-space">
            <div class="tit">
                <h2 class="float-left">
                    {{Nome()}}
                </h2>
                <router-link v-if="IsInvestidor()" :to="{path:'editar-perfil'}" class="btn btn-secondary" >Editar suas informações</router-link>
                <div class="clearfix"></div>
                <p>
                    {{Email()}}
                </p>
            </div>
        </section>
        <section v-if="existesenha">
            <h3>
                Senha
            </h3>
            <form >
                <div class="form-row align-items-center">
                    <div class="form-group text-left col-12 col-lg-4 col-xl-3">
                        <label for="password" class="float-left">
                            Senha atual
                        </label>
                        <input type="password" id="senha" name="senha" v-model="senhaAtual" />
                    </div>
                    <div class="form-group text-left col-12 col-lg-4 col-xl-3">
                        <label for="password" class="float-left">
                            Nova senha
                        </label>
                        <input type="password" id="novaSenha" name="novaSenha" v-model="senhaNova"/>
                    </div>
                    <div class="form-group text-left col-12 col-lg-4 col-xl-3">
                        <label for="password" class="float-left">
                            Repetir senha
                        </label>
                        <input type="password" id="confirmarSenha" name="confirmarSenha" v-model="confirmacaoSenhaNova"/>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-primary" v-on:click='alterarSenha()'>
                            alterar senha
                        </button>
                    </div>
                </div>
            </form>
         
        </section>

        <section v-if="!existesenha">
            <h3>
                Cadastrar Senha
            </h3>
            <form >
                <div class="form-row align-items-center">
                   <div class="form-group text-left col-12 col-lg-4 col-xl-3">
                        <label for="password" class="float-left">
                           Senha
                        </label>
                        <input type="password" id="novaSenha" name="novaSenha" v-model="senhaNova"/>
                    </div>
                    <div class="form-group text-left col-12 col-lg-4 col-xl-3">
                        <label for="password" class="float-left">
                            Repetir senha
                        </label>
                        <input type="password" id="confirmarSenha" name="confirmarSenha" v-model="confirmacaoSenhaNova"/>
                    </div>
                    <div class="col-auto">
                        <button type="button" class="btn btn-primary" v-on:click='cadastrarSenha()'>
                            cadastrar senha
                        </button>
                    </div>
                </div>
            </form>
         
        </section>
        <!-- <section>
            <h3>
                Vincular contas
            </h3>
            <div class="row accounts">
                <div class="col-lg-3 col-xl-2">
                    <a href="" class="btn btn-link">
                        Facebook
                    </a>
                </div>
                <div class="col-lg-3 col-xl-2">
                    <a href="" class="btn btn-link">
                        Linkedin
                    </a>
                </div>
                <div class="col-lg-3 col-xl-2">
                    <a href="" class="btn btn-link">
                        Google
                    </a>
                </div>
            </div>
        </section> -->
        <section class="no-space" style="display: none;">
            <h3>
                Documentos enviados por você
            </h3>
            <div class="row docs">
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="box-doc">
                        <h5>
                            Dados pessoais 
                        </h5>
                        <div class="d-flex justify-content-between">
                            <p>
                                Atualizado em 00.00.2018
                            </p>
                            <a href="">
                                Editar
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="box-doc">
                        <h5>
                            Perfil do investidor 
                        </h5>
                        <div class="d-flex justify-content-between">
                            <p>
                                Atualizado em 00.00.2018
                            </p>
                            <a href="">
                                Editar
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-4">
                    <div class="box-doc">
                        <h5>
                            Formulario de suitability
                        </h5>
                        <div class="d-flex justify-content-between">
                            <p>
                                Atualizado em 00.00.2018
                            </p>
                            <a href="">
                                Editar
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ::::::::::::::::: -->
   </div>
</template>
<style lang="scss" scoped>
    .tit {
        h2 {
            margin-right: 20px;
        }
    }
    .btn-secondary {
        margin-top: 5px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 13px;
        padding-left: 20px;
        padding-right: 20px;
        border:none;
        background: #ccc;

        &:hover {
            background: #999;
        }
    }
</style>

<script>
// import ArrayHelper from '@/utils/array-helper'
import ApiClient from '../utils/api-client'

export default {
  data() {
      return {
        senhaAtual: '',
        senhaNova: '',
        confirmacaoSenhaNova: '',
        id: '',
        existesenha : true
      }
  },
  methods: {
      Nome() {
          var nome = "";

          if(this.User.name == undefined || this.User.name == null || this.User.name == "") {
              nome = this.User.username
          } else {
              nome = this.User.name;
          }

          nome = nome.trim();
         this.existesenha = this.User.HasPass;
          return nome;

      },
      Email() {
          var email = " ";

          if(this.User.email == undefined || this.User.email == null || this.User.email == "") {
              email = this.User.username;
          } else {
              email = this.User.email
          }

          return email;
      },
      
      alterarSenha() {
            var data = this;

            data.id = this.User._id;

            if(data.senhaNova === '' || 
                data.confirmacaoSenhaNova === '' || 
                data.senhaAtual === '' )  
                this.$Notify.error('Preencha todos os campos de senha.');

            else if(data.senhaNova === data.confirmacaoSenhaNova) {

                ApiClient.alterarSenha(data)
                    .then((result) => {
                        if(result.status == 200) {
                            // sucesso
                            this.$Notify.info('A sua senha foi atualizada com sucesso.');

                            data.senhaNova = '';
                            data.senhaAtual = '';
                            data.confirmacaoSenhaNova = '';
                        } else {
                            this.$Notify.error(result.data.msg);
                        }
                    }) 
                    .catch(() => {
                        this.$Notify.error('A senha atual não confere.');
                    });
            } else {
                this.$Notify.error('As senhas não conferem.');
            }
      },
      cadastrarSenha() {
            var data = this;

            data.id = this.User._id;

            if(data.senhaNova === '' || 
                data.confirmacaoSenhaNova === '' )  
                this.$Notify.error('Preencha todos os campos de senha.');

            else if(data.senhaNova === data.confirmacaoSenhaNova) {

                ApiClient.cadastrarSenha(data)
                    .then((result) => {
                        if(result.status == 200) {
                            // sucesso
                            this.$Notify.info('A sua senha foi atualizada com sucesso.');
                            this.$store.dispatch('updateUser')
                            this.existesenha = true;

                            data.senhaNova = '';
                            data.senhaAtual = '';
                            data.confirmacaoSenhaNova = '';
                        } else {
                            this.$Notify.error(result.data.msg);
                        }
                    }) 
                    .catch(() => {
                        this.$Notify.error('A senha atual não confere.');
                    });
            } else {
                this.$Notify.error('As senhas não conferem.');
            }
      },
      IsInvestidor(){
          return document.URL.indexOf("investimentos") != -1;
      },
    //tagueamento GA
    taggingGA() {
        this.$ga.page({
            page: '/perfil/dados-pessoais',
            title: 'Dados Pessoais',
        })
    },  
  }, 
  
  computed: {
    User: function() {
        return this.$store.state.currentUser;
    }
  },
  async created() {
    //tagueamento GA
    await this.taggingGA();      
  },
}
</script>



// WEBPACK FOOTER //
// src/views/ProfileConf.vue